import { defineMessages, useIntl } from '@faceup/localization'
import { setCustomYupValidatorsErrorMessages, yup } from '@faceup/validation'
import { sharedMessages } from '../Shared/translations'

const messages = defineMessages('followUp.hooks.useYupLocalization', [
  { id: 'validationStringMin', defaultMessage: '', values: { min: true } },
  { id: 'validationStringMax', defaultMessage: '', values: { max: true } },
  { id: 'validationArrayMin', defaultMessage: '', values: { min: true } },
  { id: 'validationArrayMax', defaultMessage: '', values: { max: true } },
  { id: 'invalidEmail', defaultMessage: '' },
  { id: 'invalidUrl', defaultMessage: '' },
  { id: 'invalidIpAddress', defaultMessage: '' },
  { id: 'invalidPhone', defaultMessage: '' },
  { id: 'invalidFile', defaultMessage: '' },
  { id: 'invalidUuid', defaultMessage: '' },
] as const)

/**
 * Applies the app's localized yup error messages to the global yup locale.
 * Call once high in the tree (inside an IntlProvider). Runs on every render so
 * the locale stays in sync when the language changes.
 */
export const useYupLocalization = () => {
  const { formatMessage } = useIntl()

  yup.setLocale({
    mixed: {
      default: formatMessage(sharedMessages.invalidInputError),
      required: formatMessage(sharedMessages.invalidInputError),
      notOneOf: formatMessage(sharedMessages.invalidInputError),
      oneOf: formatMessage(sharedMessages.invalidInputError),
    },
    string: {
      min: ({ min }) => formatMessage(messages.validationStringMin, { values: { min } }),
      max: ({ max }) => formatMessage(messages.validationStringMax, { values: { max } }),
    },
    array: {
      min: ({ min }) => formatMessage(messages.validationArrayMin, { values: { min } }),
      max: ({ max }) => formatMessage(messages.validationArrayMax, { values: { max } }),
    },
  })

  setCustomYupValidatorsErrorMessages({
    email: formatMessage(messages.invalidEmail),
    url: formatMessage(messages.invalidUrl),
    ipAddress: formatMessage(messages.invalidIpAddress),
    phone: formatMessage(messages.invalidPhone),
    file: formatMessage(messages.invalidFile),
    uuid: formatMessage(messages.invalidUuid),
  })
}
